import type { ColumnMeta, ListQuery } from '@/lib/types';
import { parseFilter } from '@/grid/filters';

const NUM = new Set(['int', 'bigint', 'smallint', 'tinyint', 'float', 'real', 'decimal', 'numeric', 'money', 'smallmoney']);
const coll = new Intl.Collator('tr', { sensitivity: 'base', numeric: true });
const low = (v: unknown) => String(v ?? '').toLocaleLowerCase('tr-TR');

/** İstemci tarafı filtreleme (rapor veri görünümü): sunucu filtre semantiğiyle aynı */
export function filterRowsLocal(rows: Record<string, any>[], cols: ColumnMeta[], q: ListQuery) {
  let out = rows;
  for (const f of q.filters ?? []) {
    const c = cols.find((x) => x.name === f.field);
    const num = c && NUM.has(c.sqlType);
    const cmp = (a: unknown, b: unknown) => (num ? Number(a) - Number(b) : coll.compare(String(a ?? ''), String(b ?? '')));
    out = out.filter((r) => {
      const v = r[f.field];
      switch (f.op) {
        case 'contains': return low(v).includes(low(f.value));
        case 'notContains': return !low(v).includes(low(f.value));
        case 'startsWith': return low(v).startsWith(low(f.value));
        case 'eq': return v != null && cmp(v, f.value) === 0;
        case 'neq': return v == null || cmp(v, f.value) !== 0;
        case 'gt': return v != null && cmp(v, f.value) > 0;
        case 'gte': return v != null && cmp(v, f.value) >= 0;
        case 'lt': return v != null && cmp(v, f.value) < 0;
        case 'lte': return v != null && cmp(v, f.value) <= 0;
        case 'between': return v != null && cmp(v, f.value) >= 0 && cmp(v, f.value2) <= 0;
        case 'empty': return v == null || v === '';
        case 'notEmpty': return !(v == null || v === '');
        default: return true;
      }
    });
  }
  if (q.search) {
    const s = low(q.search);
    out = out.filter((r) => Object.values(r).some((v) => low(v).includes(s)));
  }
  return out;
}

export function sortRowsLocal(rows: Record<string, any>[], sort: { field: string; desc?: boolean }[], cols: ColumnMeta[]) {
  return [...rows].sort((a, b) => {
    for (const s of sort) {
      const c = cols.find((x) => x.name === s.field);
      const av = a[s.field], bv = b[s.field];
      const d = av == null ? (bv == null ? 0 : -1) : bv == null ? 1 : c && NUM.has(c.sqlType) ? Number(av) - Number(bv) : coll.compare(String(av), String(bv));
      if (d) return s.desc ? -d : d;
    }
    return 0;
  });
}

export { parseFilter };
